// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3LjwD","content":"styles_content__MpMd5","selectAll":"styles_selectAll__VHoEX"};